import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "5",
  height: "8",
  viewBox: "0 0 5 8",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.93061 3.93289C4.93217 4.10561 4.86107 4.27104 4.73468 4.38877L1.03482 7.83492C0.796619 8.05679 0.426839 8.05477 0.191074 7.83032C-0.0446907 7.60587 -0.0648781 7.23664 0.145012 6.98782L2.71118 3.94575L0.15222 1.02057C-0.0620975 0.77558 -0.0485632 0.40606 0.183102 0.17741C0.414768 -0.0512501 0.784429 -0.0599499 1.02659 0.15756L4.72645 3.48063C4.85496 3.59605 4.92904 3.76017 4.93061 3.93289Z"
    }, null, -1)
  ])))
}
export default { render: render }